import { addIcons } from 'ionicons';
import {
  addOutline,
  alertCircleOutline,
  arrowBackOutline,
  arrowUpOutline,
  bookmark,
  bookmarkOutline,
  buildOutline,
  calendarNumberOutline,
  calendarOutline,
  checkboxOutline,
  checkmarkCircleOutline,
  chevronBackOutline,
  closeOutline,
  cloudDownloadOutline,
  cloudUploadOutline,
  documentTextOutline,
  ellipse,
  ellipsisVerticalOutline,
  enterOutline,
  exitOutline,
  flag,
  flagOutline,
  gameControllerOutline,
  gitCommitOutline,
  glassesOutline,
  handLeftOutline,
  homeOutline,
  hourglassOutline,
  keyOutline,
  lockClosedOutline,
  logOutOutline,
  mail,
  mailOutline,
  maleFemaleOutline,
  megaphoneOutline,
  pencilOutline,
  peopleOutline,
  person,
  personOutline,
  phonePortrait,
  phonePortraitOutline,
  pinOutline,
  refreshOutline,
  repeatOutline,
  rocket,
  rocketOutline,
  sendOutline,
  settings,
  settingsOutline,
  shieldCheckmark,
  shieldCheckmarkOutline,
  time,
  timeOutline,
  trashOutline
} from 'ionicons/icons';

let appIconsRegistered: boolean = false;

export function registerIcons(): void {
  if (!appIconsRegistered) {
    appIconsRegistered = true;

    addIcons({
      addOutline,
      alertCircleOutline,
      arrowBackOutline,
      arrowUpOutline,
      bookmark,
      bookmarkOutline,
      buildOutline,
      calendarOutline,
      calendarNumberOutline,
      chevronBackOutline,
      checkboxOutline,
      checkmarkCircleOutline,
      closeOutline,
      cloudDownloadOutline,
      cloudUploadOutline,
      documentTextOutline,
      ellipse,
      ellipsisVerticalOutline,
      enterOutline,
      exitOutline,
      flag,
      flagOutline,
      gameControllerOutline,
      gitCommitOutline,
      glassesOutline,
      handLeftOutline,
      homeOutline,
      hourglassOutline,
      keyOutline,
      lockClosedOutline,
      logOutOutline,
      mail,
      mailOutline,
      maleFemaleOutline,
      megaphoneOutline,
      pencilOutline,
      peopleOutline,
      person,
      personOutline,
      phonePortrait,
      phonePortraitOutline,
      pinOutline,
      refreshOutline,
      repeatOutline,
      rocket,
      rocketOutline,
      sendOutline,
      settings,
      settingsOutline,
      shieldCheckmark,
      shieldCheckmarkOutline,
      time,
      timeOutline,
      trashOutline
    });
  }
}
